import React, { useEffect, useState } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  CartDetailedIcon,
  ChevronRightArrow,
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  DynamicButton,
} from "../../../components/common/basic";
import CountdownTimer from "../pulsenchill/components/CountdownTimer";
import { BackButton, FeatureHeader, OrderStatusCard } from "../../../components/common";
import GenericModal from "../../../components/common/genericModal";
import { useLoyalty, useTheme } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useMashupNWinPickup from "../mashupnwin/hooks/useMashupnWinPickup";
import useTriviaPickup from "../trivia/hooks/useTriviaPickup";
import RewardItemCard from "../mashupnwin/components/RewardItemCard";

const { referenceCode } = {};

const BlackFridayOrderDetails = () => {
  const history = useHistory();
  const { voucherData } = useTriviaPickup();
  const { loyaltyItem } = useLoyalty();
  const { pickupRegion, pickupLocation} = loyaltyItem || {};
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "BlackFridayHome",
        firebase_screen_class: "BlackFridayHome",
      })
    );
  }, []);


  const { themeContext, theme } = useTheme();
  const canRedeem = false;
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return (
    <>
      <MainHolder>
        <Children>
          <div>
            <BackButton onClick={() => history.push('/black-friday')} />
            <StyledText style={{ marginLeft: '29%', marginTop: '5%' }}>Order details</StyledText>
          </div>

          <Body>
            <RewardItemCard
              color={background}
              image={voucherData?.kfc?.imageUrl}
              name={voucherData?.kfc?.name}
              points={`GHS50`}
            />
            <StyledText>
              <span style={{ color: '#7F7F7F' }}>Reference code:  </span>
              {referenceCode}
            </StyledText>
            <StyledText size={11}>
              <span style={{ color: '#7F7F7F' }}>Pickup point </span>
              {pickupRegion}, {pickupLocation}
            </StyledText>
            <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

            <StyledText size={18}>Order Status</StyledText>
            <OrderStatusCard
              location={pickupLocation}
              // arrivalDate={"To be communicated"}
              stage={"in-progress"}
              enrouteDate={null}
              completedDate={null}
            />

            {/* <DynamicButton
              onClick={() => history.push('/trivia/redeem-onground')}
              label={"Complete redemption (Staff only)"}
              fullWidth
              color={background}
            /> */}
          </Body>
          <CurveOverImage
            style={{
              position: "relative",
              zIndex: 1,
              marginTop: -10,
              width: "100%",
            }}
            fill={"white"}
          />
        </Children>
      </MainHolder>
    </>
  );
};

export default BlackFridayOrderDetails;
